export const getTheHulkCategories = async (): Promise<any> => {
  if (!import.meta.env.VITE_BLUDIT_URL || !import.meta.env.VITE_BLUDIT_TOKEN) {
    throw new Error('Missing config values')
  }
  const bludItEndpoint = `${import.meta.env.VITE_BLUDIT_URL}/categories?token=${import.meta.env.VITE_BLUDIT_TOKEN}`
  const response = await fetch(bludItEndpoint)
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }
  return await response.json()
}

export const getTheHulkPages = async (key: string): Promise<any> => {
  if (!import.meta.env.VITE_BLUDIT_URL || !import.meta.env.VITE_BLUDIT_TOKEN) {
    throw new Error('Missing config values')
  }
  const bludItEndpoint = `${import.meta.env.VITE_BLUDIT_URL}/categories/${key}?token=${import.meta.env.VITE_BLUDIT_TOKEN}`
  const response = await fetch(bludItEndpoint)
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }

  return await response.json()
}